import { useEffect } from 'react';

export const useScrollEvent = (isOpen: boolean, onDismiss: () => void) => {
  useEffect(() => {
    if (window !== undefined && !isOpen) {
      window.removeEventListener('scroll', onDismiss, false);
    }
  }, [isOpen, onDismiss]);
};

export default useScrollEvent;
